import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '@services/api.service';
import { NguCarouselConfig } from '@ngu/carousel';

@Component({
  selector: 'ew-add-money',
  templateUrl: './add-money.component.html',
  styleUrls: ['./add-money.component.scss'],
})
export class AddMoneyComponent implements OnInit {
  currencies: any[] = [];
  provider: any;
  @ViewChild('myCarousel') myCarousel: any;
  carouselConfig: NguCarouselConfig = {
    grid: { xs: 3, sm: 3, md: 3, lg: 3, all: 0 },
    load: 3,
    slide: 1,
    interval: { timing: 4000, initialDelay: 1000 },
    loop: false,
    touch: true,
    velocity: 0.2,
    vertical: {
      enabled: true,
      height: 440,
    },
    point: {
      visible: true,
      hideOnSingleSlide: true,
    },
  };
  carouselItems: any[any] = [1, 2, 3, 4, 5, 6, 7];
  mainItems: any[] = [...this.currencies];

  constructor(private API: ApiService) {
    this.API.getJson('currencies').subscribe((data: any) => {
      this.currencies = data.data;
    });
    this.API.getJson('providers').subscribe((data: any) => {
      this.provider = data.data[3];
    });
  }

  ngOnInit(): void {}

  carouselTileLoad(data: any) {}
}
